export default __webpack_public_path__ + "static/media/Cash-red.7bd7a64b.svg";